import React, { useEffect, useState } from 'react';
import { promoBarPropTypes } from './PromoBarPropTypes';
import Container from '@Theme/natucare/components/Container/Container';
import CountdownTimer from './components/CountdownTimer/CountdownTimer';
import { isValidDate } from '@Theme/natucare/modules/Header/components/PromoBar/utils/isValidDate';
import { calculatePromoDates } from '@Theme/natucare/modules/Header/components/PromoBar/utils/calculatePromoDates';
import { isPromoActive } from '@Theme/natucare/modules/Header/components/PromoBar/utils/isPromoActive';
import * as styles from './PromoBar.module.scss';
const PromoBar = _ref => {
  let {
    text,
    startDate,
    endDate,
    counter,
    link,
    variant,
    isPromoVisibleProp
  } = _ref;
  if (!text && !startDate && !endDate && !counter && !link && !variant) {
    return null;
  }
  const {
    0: isPromoVisible,
    1: setIsPromoVisible
  } = useState(isPromoVisibleProp);
  useEffect(() => {
    if (isValidDate(startDate) && isValidDate(endDate)) {
      const {
        start,
        end
      } = calculatePromoDates({
        startDate,
        endDate
      });
      setIsPromoVisible(isPromoActive(start, end));
    }
  }, [startDate, endDate]);
  if (!isPromoVisible) {
    return null;
  }
  const combinedText = text + (link !== null && link !== void 0 && link.label && link !== null && link !== void 0 && link.href ? ` <a href="${link.href}" class="${styles.rootActionLink}">${link.label}</a>` : '');
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${variant ? styles[`root${variant}`] : ''}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, text && /*#__PURE__*/React.createElement("div", {
    className: styles.rootText,
    dangerouslySetInnerHTML: {
      __html: combinedText
    }
  })));
};
export default PromoBar;